<div id="messagesDropDown" class="dropdown d-inline-block">
    <a class="dropdown-toggle no-caret pl-2 pr-2 pos-relative" (click)="onClickNote()" id="messages"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <!-- <i class="fa fa-bell-o btnn2" aria-hidden="true"></i> -->
        <div *ngIf="Count == 0" class="notify"></div>
        <!-- <div *ngIf="Count != 0" class="notify-count">{{Count}}</div> -->
    </a>
    <div class="dropdown-menu dropdown-menu-right rounded-0 p-0 mt-3 box-shadow " aria-labelledby="messages">
        <div class="clearfix">
            <ul class="nav nav-tabs nav-justified border-0 bg_clr">
                <li class="nav-item">
                    <a id="messagesTabs1" class="nav-link active " data-toggle="tab" href="#comments"
                        aria-haspopup="true" aria-expanded="false"><i class="fa fa-bell" ngbTooltip="Alerts"></i></a>
                </li>
                <li class="nav-item">
                    <a id="messagesTabs2" class="nav-link " data-toggle="tab" href="#comments2" aria-haspopup="true"
                        aria-expanded="false"><i class="fa fa-users"></i></a>
                </li>
            </ul>
        </div>
        <div class="tab-content " style="overflow: scroll;" perfectScrollbar>
            <div class="tab-pane active" id="comments">

                <div class="list ">
                    <!-- <ngx-spinner bdOpacity=0.9 bdColor="white" size="default" color="#ff6801" type="ball-elastic-dots" [fullScreen]="false"><br>
                        <p style="color:#0b3999"> Loading... </p>
                    </ngx-spinner> -->
                    <div *ngFor="let message of messages">
                        <a *ngIf="message.notification_status == 4"
                            style='background: #f2f2f2; border-right: 3px solid #0b3999'>
                            <img [src]="message.sub_image  || Dummy">
                            <div class="list-content">
                                <h3>{{message.notification_title}} <span class="pull-right">
                                        <i class="fa fa-clock-o"> {{message.notification_udt | date:'MMM d, h:mm'}} </i>
                                        {{message.notification_utd}}</span></h3>
                                <p>{{message.notification_text}}</p>
                            </div>
                        </a>
                        <!-- 0 is using for sitrap  -->
                        <a *ngIf="message.notification_status == 1">
                            <img [src]="message.sub_image  || Dummy">
                            <div class="list-content" *ngIf="message.notification_type == 0"
                                [routerLink]="['/views/sitrap']">
                                <h3>{{message.notification_text}} <span class="pull-right"><i
                                            class="fa fa-clock-o">{{message.notification_udt | date:'MMM d, h:mm'}}</i>
                                        {{message.notification_utd}}</span></h3>

                            </div>
                            <div class="list-content" *ngIf="message.notification_type !== 0">
                                <h3>{{message.notification_title}} <span class="pull-right"><i
                                            class="fa fa-clock-o">{{message.notification_udt | date:'MMM d, h:mm'}}</i>
                                        {{message.notification_utd}}</span></h3>
                                <p>{{message.notification_text}}</p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="tab-pane" id="comments2">
                <div class="list">
                    <!-- <ngx-spinner bdOpacity=0.9 bdColor="white" size="default" color="#ff6801" type="ball-elastic-dots" [fullScreen]="false"><br>
                        <p style="color:#ff6801"> Loading... </p>
                    </ngx-spinner> -->
                    <div *ngFor="let message of memList" href="javascript:void(0);" class="transition">
                        <a>
                            <img [src]=" message.org_log || Dummy">
                            <div class="list-content">
                                <h3>{{message.org_name}} <span class="pull-right"><i class="fa fa-clock-o"></i>
                                        {{message.notification_utd}}</span></h3>
                                <p class="p_width">{{message.org_desc}}</p>

                                <button (click)="accpetInvitation(message.invite_id)" class="btn btn-success my_btn2"><i
                                        class="fa fa-check"></i></button>
                                <button (click)="rejectInvitation(message.invite_id)" class="btn btn-danger my_btn"><i
                                        class="fa fa-times"></i></button>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="dropdown d-inline-block">
    <!-- Logout  -->
    <a class="dropdown-toggle no-caret pl-2 pr-2" id="user-menu" (click)="getUserOrg()" data-toggle="dropdown"
        aria-haspopup="true" aria-expanded="false">
        <span *ngIf="userSession && userSession.length"><i class="fa fa-clock-o" aria-hidden="true"></i></span>
        <i class="fa fa-user-o btnn2" aria-hidden="true" title={{userMsisdn}}></i>
        <span>&nbsp;&nbsp;<b>{{orgName}}</b>
        </span>
    </a>
    <!--Drop down Menu  -->
    <div class="dropdown-menu dropdown-menu-right rounded-0 mt-3 p-0 box-shadow" aria-labelledby="user-menu">
        <div class="user-menu">
            <div class="user-info2 p-3" [routerLink]="['/views/profile']">
                <img class="hd-img" [src]="imagepath || Dummy " alt="user-img">
                <span class="ml_10">
                    {{userMsisdn}}
                </span>
            </div>
            <hr class="profile-hr">
            <div class="main-div" perfectScrollbar>
                <a *ngFor="let item of orgList" class="dropdown-item" (click)="UpdateUserOrg(item)">
                    <i *ngIf="item.can_delete === '1'" class="fa fa-trash pos_eye"
                        (click)="deleteOpen(delete,item.org_id )" placement="left" ngbTooltip="Delete"></i>
                    <div class="ddd">
                        <img class="pf-img" [src]="item.org_logo || Dummy" alt="org-img">
                    </div>
                    <div class="hh">

                        <span class="mt-1 mb-0 " placement="bottom" [ngbTooltip]="item.org_name">
                            {{item.org_name}}
                        </span>
                    </div>
                    <div class="lne">
                        <hr class="body-hr">
                    </div>
                </a>
            </div>
        </div>
        <!-- Logout Button -->
        <div class="drop_foot">
            <div class="row momargins">
                <div class="col-xl-8 col-md-8 col-sm-8 col-8">
                    <a routerLink="/views/organization/list"> <button class="btn btn-danger ng-star-inserted">Add
                            Organization</button></a>

                </div>
                <div class="col-xl-4 col-md-4 col-sm-4 col-4">
                    <button class="btn btn-dark " (click)="LogoutUser(sessionContent)">Logout</button>
                </div>
                <div class="col-xl-3 col-md-3 col-sm-3 col-3"></div>
            </div>
        </div>

    </div>
</div>


<!-- Logout modal -->
<ng-template #sessionContent let-modal>
    <div class="modal-header modal_head">
        <h4 class="modal-title">Logout</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true" class="whitee">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p class="modal_p">
            Are you sure you want to logout?
        </p>
    </div>
    <hr class="modal_hr">
    <div class="modal-footer">
        <button (click)="logout()" class="btn my_warning_btn">
            Confirm
        </button>
        <button class="btn btn-inverse" (click)="modal.close('Close click')">
            Cancel
        </button>
    </div>
</ng-template>